/**
 * 一問一答：質問グループクラス
 */
export default class Dialog {
  constructor({ id, title, questionCount, answerCount, locked, revision }) {
    this.id = id
    this.title = title
    this.questionCount = questionCount
    this.answerCount = answerCount
    this.locked = locked
    this.revision = revision
  }

  get isNotStarted() {
    return this.answerCount === 0
  }

  get isInProgress() {
    return (
      this.answerCount > 0 &&
      this.answerCount < this.questionCount
    )
  }

  get isDone() {
    return this.answerCount === this.questionCount
  }

  get isLocked() {
    return this.locked === true
  }
}
